import { computed } from 'vue'
import { createQuery } from '@/queries'
import { getMyStyleData } from '@/features/my-style/api/my-style'
import type { MyStylePageData } from '@/types/my-style'
import type { AxiosResponse } from 'axios'

type MyStyleResponse = Awaited<
  ReturnType<typeof getMyStyleData>
> extends AxiosResponse<infer T>
  ? T
  : never

export const useMyStyleQuery = () => {
  return createQuery<MyStyleResponse>({
    key: computed(() => ['my-style']),
    fetcher: async () => {
      const response = await getMyStyleData()
      return response.data
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: computed(() => true)
  })
}

